import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

import CitiesList, { type CityType } from "./cities-list";
import { ChevronIcon } from "./icons";

export type { CityType } from "./cities-list";

export interface RegionType {
  cities: CityType[];
  name: string;
}

interface RegionProps {
  region: RegionType;
}

export default function Region({ region }: RegionProps) {
  return (
    <AccordionItem className="border-0 pt-[30px] md:pt-20" value={region.name}>
      <AccordionTrigger className="group flex items-center py-2 text-30/[1em] text-white underline decoration-1 decoration-pale-lavender underline-offset-25">
        {region.name}
        <ChevronIcon className="ml-[50px] transition-transform group-data-[state=open]:rotate-180 md:hidden" />
      </AccordionTrigger>
      <AccordionContent className="pt-5 pb-[50px] md:pt-10 md:pb-0">
        <CitiesList cities={region.cities} />
      </AccordionContent>
    </AccordionItem>
  );
}
